export interface UserIdentity {
  globalId: string
  email: string
  name: string
  locale: string
}

export interface BrazeConfig {
  apiKey: string
  sdkEndpoint: string
  enableLogging?: boolean
  allowUserSuppliedJavascript?: boolean
}

export const getBrazeConfig = (): BrazeConfig | null => {
  const apiKey = window?.ENV?.BRAZE_API_KEY
  const sdkEndpoint = window?.ENV?.BRAZE_SDK_ENDPOINT

  if (!apiKey || !sdkEndpoint) {
    return null
  }

  return {
    apiKey,
    sdkEndpoint,
    enableLogging: process.env.NODE_ENV === 'development',
    // Allow Braze to execute JavaScript in in-app messages and content cards
    allowUserSuppliedJavascript: true,
  }
}

export const isBrazeAvailable = (): boolean => {
  return !!window?.braze
}

export const isBrazeInitialized = (): boolean => {
  return isBrazeAvailable() && !!window.braze?.isInitialized?.()
}
